// @ts-nocheck
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { FC } from "react";

export default (type: string) => {
    return (x => createWidgetElement(type, typeof x.fields === "undefined" ? { fields: x } : x)) as FC<any>;
};
